import customSelect from 'custom-select'
export default {
  name: 'custom-select',

  componentDidMount () {
    const customSelectEl = customSelect(this.el, {
      containerClass: 'custom-select-container',
      openerClass: 'custom-select-opener',
      panelClass: 'custom-select-panel',
      optionClass: 'custom-select-option',
      optgroupClass: 'custom-select-optgroup',
      isSelectedClass: 'is-selected',
      hasFocusClass: 'has-focus',
      isDisabledClass: 'is-disabled',
      isOpenClass: 'is-open',
    })

    const iconContainer = document.createElement('div')
    iconContainer.innerHTML = `
      <div class="custom-select-icon-wrapper">
        <svg width="24" height="25" viewBox="0 0 24 25">
          <path d="m17.5 10-5 5-5-5" stroke="#FFF" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    `

    customSelectEl[0].container.appendChild(iconContainer.firstElementChild)

    if (this.props && this.props.isContact) {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      const subject = urlParams.get('subject')

      if (subject === 'demo') {
        const demoOption = [...customSelectEl[0].select.options].filter(option => option.value.includes('démonstration'))[0]

        customSelectEl[0].value = demoOption.value
      } else if (subject === 'devis') {
        const demoOption = [...customSelectEl[0].select.options].filter(option => option.value.includes('devis'))[0]

        customSelectEl[0].value = demoOption.value
      }
    }

    customSelectEl[0].select.addEventListener('change', (e) => {
      const value = e.target.value

      if (this.props && this.props.isSort) {
        e.target.querySelectorAll('option').forEach(option => {
          if (option.value === value) {
            window.location.href = option.dataset.url
          }
        })
      }
    })
  },
}
